import matrixData from "../other/matrix-data";

const materialsPageData = {
    mainTitle : "Our Material Matters",
    sectionOne : {
        // subtitle : "To determine our material matters, we followed a robust process of analysis and Stakeholder engagement that incorporated both quantitative and qualitative elements.",
        borderLeftBox : {
            title : "The ESG issues that matter most to SAB ",
            subtitle : "To contribute to Vision 2030 effectively and be a responsible corporate citizen, SAB must engage with its material stakeholders, assimilate the critical issues at play, and incorporate all material issues into our strategy.",
        },
        paragraph : "To determine our material matters, we followed a robust process of analysis and Stakeholder engagement that incorporated both quantitative and qualitative elements.",
        cards : [
            {
                icon : {
                    name : "understand.svg",
                    alt : "",
                },
                title : "Understand",
                subtitle : "SAB maintains ongoing two-way communication with its key Stakeholders, while also keeping an eye on market developments for a deep understanding of its operating context.",
            },
            {
                icon : {
                    name : "identify.svg",
                    alt : "",
                },
                title : "Identify",
                subtitle : "Armed with an understanding of its context, SAB conducted an externally-facilitated survey with the SAB ESG Working Group members, followed by a workshop to identify the universe of potentially material issues affecting SAB and its Stakeholders. Interviews with some of SAB’s executives, including the CEO and CFO, impacted the material matters that were finally presented to the SAB ESG Steering Committee for discussion and confirmation.",
            },
            {
                icon : {
                    name : "assess.svg",
                    alt : "",
                },
                title : "Assess",
                subtitle : "Once a comprehensive list of important issues was identified, SAB conducted an externally-facilitated materiality survey with internal and external Stakeholders – including customers, business partners, and suppliers – to assess what these issues mean to them and how important they are.",
            },
            {
                icon : {
                    name : "prioritise.svg",
                    alt : "",
                },
                title : "Prioritise",
                subtitle : "Following an in-depth analysis of the survey results, SAB crafted a materiality matrix that it believes highlights the most important issues faced by the Bank and its Stakeholders.",
            },
        ]
    },
    sectionTwo : {
        title : "SAB’s materiality matrix",
        sutitle : "As outlined in the following materiality matrix, environmental materiality issues for SAB include sustainable finance, emissions, water, waste and biodiversity impacts. Material issues in the social dimension entail local communities, diversity, employment, customer privacy protection, social aspects of our suppliers, training and education, and occupational health and safety. Economic material issues cover economic performance, indirect economic impacts, and procurement practices, while governance issues include Vision 2030 adherence, ethics and governance frameworks.",
        image : {
            src : "matrix-one.jpg",
            alt : "SAB’s materiality matrix plan",
        },
        matrixData : {
            matrix : matrixData,
            xAxis : {
                label : "Importance to SAB",
            },
            yAxis : {
                label : "Importance to external Stakeholders"
            },
            levels : ["Low", "Medium", "High"],
            keys : [
                {
                    icon : "environment.svg",
                    text : "Environment"
                },
                {
                    icon : "economic.svg",
                    text : "Economic"
                },
                {
                    icon : "social.svg",
                    text : "Social"
                },
                {
                    icon : "governance.svg",
                    text : "Governance"
                },
            ]
        },
        tabsView : {
            title : "SAB’s material issues",
            tabs : {
                headers : ["High", "Medium", "Low"],
                tableHeaders : ["Material issue", "Strategic theme", "Description", "ESG report"],
                elements : [
                    [
                        {
                            title : "Vision 2030 adherence",
                            icon : "hand-shack.svg",
                            description : "To be a responsible corporate citizen, SAB must align its commercial and ESG strategies with the principles and objectives of the Kingdom’s Vision 2030.",
                            page : "page 19",
                        },
                        {
                            title : "Economic performance ",
                            icon : "hand-leaves-blue.svg",
                            description : "SAB and most businesses depend on generating returns and profits to remain sustainable. SAB would soon become unsustainable if it fails to generate consistently sound economic performances.",
                            page : "page 75",
                        },
                        {
                            title : "Ethics",
                            icon : "hand-shack.svg",
                            description : "Ethical practices and behaviour are the foundation upon which proper corporate governance is built, and prevents fraud and corruption.",
                            page : "page 57",
                        },
                        {
                            title : "Local communities",
                            icon : "runners.svg",
                            description : "The Kingdom’s communities are integral to SAB’s operations and our operational efficiency is essential to their ongoing welfare. Maintaining healthy relations with our communities – and supporting them when we can – is a high priority for the Bank. ",
                            page : "page 28",
                        },
                        {
                            title : "Sustainable finance",
                            icon : "hand-leaves-blue.svg",
                            description : "SAB’s greatest contribution to Vision 2030 and the mitigation of climate change will be through providing attractive finance to “green” projects and services. As a result, SAB is ramping up its green investments massively over the next 3 years.",
                            page : "page 82",
                        },
                        {
                            title : "Customer privacy protection",
                            icon : "runners.svg",
                            description : "Cybercrime and ‘hacking’ have become more prevalent and sophisticated. SAB, along with most organisations around the world, has to ensure that its digital security systems are robust enough to prevent any theft of customer data.",
                            page : "page 42, 59",
                        },
                        {
                            title : "Employment",
                            icon : "runners.svg",
                            description : "Being unemployed generally marginalises people from the mainstream of society. SAB tackles this material concern through a range of programmes that enable citizens to access employment, develop skills and enter higher education.",
                            page : "page 34",
                        },
                        {
                            title : "Diversity ",
                            icon : "runners-green.svg",
                            description : "Those countries with the highest diversity rates have also proven to be the most productive. SAB is actively building diversity levels in our own ranks to unlock the talent in all segments of our society.",
                            page : "page 37",
                        },
                        {
                            title : "Governance framework ",
                            icon : "hand-shack.svg",
                            description : "Good corporate governance relies on best practice policies and procedures to function correctly. SAB is working to establish a best practice framework and processes.",
                            page : "page 50",
                        },
                        {
                            title : "Emissions",
                            icon : "leave-elct.svg",
                            description : "Human-generated emissions into the Earth’s atmosphere are the single biggest cause of global warming. SAB has prioritised reducing its own emissions to Net Zero the bank is committed to reviewing the emissions of its financed portfolio during the course of 2023.",
                            page : "page 83",
                        },
                        {
                            title : "Water consumption ",
                            icon : "leave-elct.svg",
                            description : "The Kingdom is a water-scarce country that can be made even drier and hotter by climate change. SAB’s new headquarters and our water saving or recycling initiatives are designed to minimise our own water consumption.",
                            page : "page 84",
                        },
                    ],
                    [
                        {
                            title : "Indirect economic impacts",
                            icon : "hand-leaves.svg",
                            description : "Providing sustainable finance and supporting projects such as the SGI enables their multiplier effects to generate substantial and positive economic impacts.",
                            page : "page 75",
                        },
                        {
                            title : "Waste management",
                            icon : "leave-elct.svg",
                            description : "Waste from operations is still inevitable, although SAB has made great strides into eliminating paper usage and recycling the waste that we do generate.",
                            page : "page 84",
                        },
                        {
                            title : "Training and education",
                            icon : "target.svg",
                            description : "An educated population is a productive one. SAB is working hard to raise the numbers of productively educated people through internal programmes for our employees and external financial literacy programmes made available to citizens of the Kingdom. ",
                            page : "page 36",
                        },
                        {
                            title : "Occupational health and safety",
                            icon : "runners.svg",
                            description : "Following COVID-19, employees are under more stress than before. SAB has launched initiatives to ensure that employees are safe in the workplace. ",
                            page : "page 75",
                        },
                    ],
                    [
                        {
                            title : "Biodiversity impacts ",
                            icon : "trees.svg",
                            description : "SAB’s own operations have little direct impact on the Kingdom’s biodiversity, but SAB contributes to biodiversity through its tree-planting efforts with SGI. ",
                            page : "page 31, 32",
                        },
                        {
                            title : "Social assessment of suppliers ",
                            icon : "runners.svg",
                            description : "SAB acknowledges its responsibility for ensuring that our suppliers are ESG-aware and do not undermine our ESG objectives. We have updated the Bank’s vendor registration requirements to incorporate ESG factors when assessing new suppliers.",
                            page : "page 76",
                        },
                        {
                            title : "Procurement practices ",
                            icon : "hand-shack.svg",
                            description : "SAB is becoming stringent in ensuring that we procure from suppliers that are aligned with the Bank’s ethics and ESG programmes.",
                            page : "page 75",
                        },
                    ],
                    
                ]
            }
        },
        tableTabs : {

            title : "SAB’s material issues",
            
            
        },
        borderLeftBox : {
            title : "Ongoing materiality",
            subtitle : "In this section, we reported the outcomes of SAB’s first materiality exercise. As SAB continues on its ESG journey, we will keep engaging with stakeholders on the important issues. Our material matters will doubtlessly shift in response to our operating conditions and as the Bank’s internal dialogue matures over time – we will use this information to refine our ESG approach and communication to stakeholders.",
        }
    }
};

export default materialsPageData;